import { makeStyle } from '../../../../../utils';
import { columnCenter, h6, black, rowCenter, h5, caption, blackMedium, secondary } from '../../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle([columnCenter, { alignItems: 'stretch' }]);

styles['field'] = makeStyle({ margin: '12px', alignSelf: 'stretch', minWidth: 200 });

styles['my_loc'] = makeStyle([secondary, { marginLeft: 16, cursor: 'pointer' }]);

styles['location_dialog_header'] = makeStyle([rowCenter, {
    justifyContent: 'space-between', padding: '10px 10px 10px 22px'
}], { padding: '20px 20px 20px 32px' });

styles['location_dialog_title'] = makeStyle([h6, black, { letterSpacing: '-0.35px' }]);

styles['upload_title'] = makeStyle([rowCenter, h5, black, { letterSpacing: '-0.35px', margin: '24px 12px 28px' }]);

styles['optional'] = makeStyle([caption, blackMedium, { letterSpacing: '0.2px', marginLeft: 8 }]);

styles['add_image_container'] = makeStyle({ overflow: 'auto', padding: '0 12px', marginBottom: 12 });

export default styles;